import { Global } from '@utils/common';
import { ID } from './ID';

export const getCustomColumnTypes = () => ({
  ADDER: Global.lots.custom_column_headers.column_types.adder,
  DESCRIPTIVE: Global.lots.custom_column_headers.column_types.descriptive,
  QUALIFYING: Global.lots.custom_column_headers.column_types.qualifying,
} as const);

export type CustomColumnType = ReturnType<typeof getCustomColumnTypes>[
  keyof ReturnType<typeof getCustomColumnTypes>
];

export const getColumnTypes = (): CustomColumnType[] =>
  Object.values(getCustomColumnTypes());

export const getAdderColumnType = (): CustomColumnType =>
  getCustomColumnTypes().ADDER;

export const getDescriptiveColumnType = (): CustomColumnType =>
  getCustomColumnTypes().DESCRIPTIVE;

export const getQualifyingColumnType = (): CustomColumnType =>
  getCustomColumnTypes().QUALIFYING;

export interface CustomColumnItem {
  _destroy?: boolean;
  answer_option?: number | null;
  column_type: CustomColumnType;
  custom_column_header_id: ID;
  display_text: string;
  id: ID;
  is_supplier_visible: boolean;
  line_item_id: ID;
  new_header_index?: number | string;
  qualifying_equality: string;
}

export type CustomColumnItemWithOrderIndex = CustomColumnItem & { column_order_index: number };
